// extracted by mini-css-extract-plugin
module.exports = {"cardColumn":"SingleContent_cardColumn__yie29","card":"SingleContent_card__2sWh7"};